import { useListsContext } from 'modules/listIndex/contexts';
import { ListFolderRow } from './ListFolderRow';

export const ListFolderRows = () => {
  const { listFolders } = useListsContext();
  return listFolders.map((folder) => <ListFolderRow key={folder.id} folder={folder} />);
};
